import api from './api'

const createCompliment = (compliment) => api.post('compliment', compliment)

const findComplimentByUser = (userName) => api.get('compliment?recipient=' + userName)

export default { createCompliment, findComplimentByUser }
